var formatTime = function formatTime(duration) {
  var minutes = Math.floor(duration % 3600 / 60).toString();
  var seconds = Math.floor(duration % 60).toString().padStart(2, '0');
  return "".concat(minutes, ":").concat(seconds);
};
export default formatTime;